import { TextField } from "@mui/material";
import { PaperCard } from "../../../../shared/ui/paper-card/paper-card.component";

interface ListCarsSearchComponentProps {
  props: {
    termMask: string;
    handleTermMaskChange: (term: string) => void;
  };
}

export const ListCarsSearchComponent: React.FC<ListCarsSearchComponentProps> = ({ props }) => {
  const { termMask, handleTermMaskChange } = props;

  return (
    <PaperCard title="Buscar Carros">
      <TextField
        size="small"
        margin="dense"
        id="term"
        label="Placa ou Chassi"
        variant="standard"
        name="term"
        fullWidth
        value={termMask}
        onChange={(e) => {
          handleTermMaskChange(e.target.value);
        }}
      />
    </PaperCard>
  );
};
